import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router'

import { createLabeledPathWithI18n } from '~/apps/ninesegsAnalyzer/routes/paths'
import { Suspense } from '~/components/elements/Suspense'
import { useCommonQuery } from '~/hooks/useCommonQuery'
import { useIsMforceUser } from '~/hooks/useIsMforceUser'

import { AllowedDomainList } from './components/AllowedDomainList'
import { Dialogs } from './components/Dialogs'
import { useBrandAccountId } from './hooks/useBrandAccountId'

export const BrandAccountAllowedDomainListPage = () => {
  const { t } = useTranslation()
  const createLabeledPath = React.useMemo(
    () => createLabeledPathWithI18n(t),
    [t],
  )
  const brandAccountId = useBrandAccountId()
  const isMforceUser = useIsMforceUser(brandAccountId)
  const { isLoading } = useCommonQuery()

  if (!isLoading && !isMforceUser) {
    const { to } = createLabeledPath('brandAccount', { brandAccountId })

    return <Navigate replace={true} to={to} />
  }

  return (
    <Suspense loading={isLoading}>
      <AllowedDomainList />

      <Dialogs />
    </Suspense>
  )
}
